var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 99 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C94B7",
    fillRule: "evenodd",
    d: "M24.8 44.5v-9.9a24.7 24.7 0 1 1 49.4 0v10c5.5 0 10 4.4 10 9.9v24.7c0 5.5-4.5 9.9-10 9.9H24.9a9.9 9.9 0 0 1-10-9.9V54.4c0-5.4 4.5-9.9 10-9.9Zm39.6-9.9v10H34.7v-10a14.8 14.8 0 1 1 29.7 0Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosed);
export default __webpack_public_path__ + "static/media/lock_closed.08c0863fbdb72af1059297f37b29527f.svg";
export { ForwardRef as ReactComponent };